var _module_exports = "<span>Thank you for posting your first project on Codeable. Your discount will be deducted from the final price.</span>";;
var path = 'views/flashes/coupon_code.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;